// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { Routes, Route } from 'react-router-dom';
import BudgetFeedIOHome from './BudgetFeedIO';

export function BudgetFeedRoutes() {
  return (
    <Routes>
      <Route index element={<BudgetFeedIOHome />} />
      <Route path="upload" element={<BudgetFeedIOHome />} />
      <Route path="budgetfeedio" element={<BudgetFeedIOHome />} />
    </Routes>
  );
}
